import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ConfirmationService, SelectItem } from 'primeng/api';

import {  UserRoles,  Features } from '../../../models/models';
import { IFeaturesService,
         IApplicationContextService,
         IOpsViewerMessagesService } from '../../../services/services';
import { Title } from '@angular/platform-browser';
import { IUserManagerService } from '../../../services/iUserManager.service';
import { first } from 'rxjs/operators';
import { CompanyClient, User, UserClient } from '../../../services/nswag/nswagclient';

type MessageSeverity = 'success' | 'info' | 'warn' | 'error' | 'secondary' | 'contrast';

interface UserListMessage {
  severity: MessageSeverity;
  summary?: string;
  detail?: string;
}

@Component({
    // tslint:disable-next-line:component-selector
    selector: 'user-list',
    templateUrl: './user-list.component.html',
    styleUrls: ['./user-list.component.css'],
    standalone: false
})
export class UserListComponent implements OnInit {

  public isCompanyAdministrationFeatureEnabled = false;
  public featuresReady = false;

  public cols: any[] = [];
  public colsReady = false;

  public user: User = new User();
  public usersReady = false;
  public users: User[] = [];
  public userRoles: SelectItem[] = [];

  public companyNamesSelection: SelectItem[] = [];

  isUserReady = false;
  everythingReady = false;

  messages: UserListMessage[] = [];

  constructor(
    private _userClient: UserClient,
    private _userManagerService:IUserManagerService,
    private _companyService: CompanyClient,
    private _featureService: IFeaturesService,
    private _router: Router,
    private _confirmationService: ConfirmationService,
    private _titleService: Title,
    private _applicationContextService: IApplicationContextService,
    private _messageService: IOpsViewerMessagesService
   ) { }

  ngOnInit() {
    this.setPageTitle();
    this.getUsers();
    this.getFeatures();
    this.getAuthenticatedUser();
  }

  setPageTitle() {
    this._titleService.setTitle('OpsViewer Users');
  }

  getFeatures() {
    this._featureService.isFeatureEnabled(Features.CompanyAdministration).subscribe(
      result => {
        this.isCompanyAdministrationFeatureEnabled = result;
        this.featuresReady = true;
        this.setColumns();
      }
    );
  }

  setColumns() {
    if (this.isCompanyAdministrationFeatureEnabled) {
      this.cols = [
        {field: 'email', header: 'Email', width: '', filterMatchMode: 'contains'},
        {field: 'name', header: 'Name', width: '', filterMatchMode: 'contains'},
        {field: 'companyNames', header: 'Companies', width: '', filterMatchMode: 'contains', alternativeFilterField: 'companyNames'},
        {field: '', header: '', width: '90px'},
      ];
    } else {
      this.cols = [
        {field: 'email', header: 'Email', width: '250px', filterMatchMode: 'contains'},
        {field: 'name', header: 'Name', width: '250px', filterMatchMode: 'contains'},
        {field: 'isEmployee', header: 'Employee?', width: '100px' },
        {field: 'role', header: 'Role', width: '100px', filterMatchMode: 'in'},
        {field: 'companyNames', header: 'Companies', width: '250px', filterMatchMode: 'contains', alternativeFilterField: 'companyNames'},
        {field: 'allCompanies', header: 'Global?', width: '75px' },
        {field: '', header: '', width: '60px'},
      ];
    }

    this.userRoles = [];
    this.userRoles.push({ label: UserRoles.admin, value: UserRoles.admin });
    this.userRoles.push({ label: UserRoles.editor, value: UserRoles.editor });
    this.userRoles.push({ label: UserRoles.reader, value: UserRoles.reader });

    this.colsReady = true;
    this.checkIfEverythingReady();
  }

  login() {
    //this._msalService.login();
  }
  logout() {

    //this._msalService.logout();
  }
  getUsers() {
    this.messages = [];

    this._userClient.get().subscribe(
      results => {
        this.users = results;
        this.users.forEach(user => {
          const userWithcompanies = user as any;
          if (!userWithcompanies.name) { userWithcompanies.name = user.firstName + ' ' + user.lastName; }
        });
        this.getCompanies();
      },
      error => {
        this.handleError(error, 'Could not get users');
      }
    );
  }

  getCompanies() {
    this._companyService.get().subscribe(
      results => {
        this.companyNamesSelection = [];
        results.forEach(result => {
          this.companyNamesSelection.push({ label: result.name, value: result.id });
          if (this.isCompanyAdministrationFeatureEnabled) {
            const users = this.users.filter(u => result.id && u.companyRoles && u.companyRoles.findIndex(r => r.companyId === result.id) >= 0);
            if (users) {
              users.map(u => {
                const userWithcompanies = u as any;
                if (!userWithcompanies.companyNames) {
                  userWithcompanies.companyNames = result.name;
                } else {
                  userWithcompanies.companyNames = userWithcompanies.companyNames + ', ' + result.name;
                }
              });
            }
          } else {
            const users = this.users.filter(user => result.id && user.companyIds != null && user.companyIds.includes(result.id));
            users.forEach(user => {
              const userWithcompanies = user as any;
              if (!userWithcompanies.companies) { userWithcompanies.companies = []; }
              const companyToAdd = { label: result.name, value: result.id };
              if (!userWithcompanies.companies.includes(companyToAdd)) { userWithcompanies.companies.push(companyToAdd); }
              if (!userWithcompanies.companyNames) {
                userWithcompanies.companyNames = companyToAdd.label;
              } else {
                userWithcompanies.companyNames = userWithcompanies.companyNames + ', ' + companyToAdd.label;
              }
            });
          }
        });
        this.usersReady = true;
        this.checkIfEverythingReady();
      },
      error => {
        this.handleError(error, 'Could not get companies');
      }
    );
  }

  getAuthenticatedUser() {

    this._userManagerService.getCurrentUser().subscribe(u=>{
      this.user = u;
      this.isUserReady = true;
      this.checkIfEverythingReady();
    });

    // this._msalService.getUserEmail().subscribe(
    //   userEmail => {
    //     if (userEmail) {
    //       this._userService.getUserByEmail(userEmail).subscribe(
    //         userResult => {
    //           this.user = userResult;
    //           this.isUserReady = true;
    //           this.checkIfEverythingReady();
    //         },
    //         error => { this.handleError(error, 'Could not get user'); }
    //       );
    //     }
    //   },
    //   error => { this.handleError(error, 'Could not get user'); }
    // );
  }

  checkIfEverythingReady() {
    this.everythingReady = this.featuresReady && this.colsReady && this.usersReady && this.isUserReady;
  }

  // SuperAdmin checking only once CompanyAdmin Feature is used, otherwise
  // original Admin role has ability to delete
  isSuperAdmin(): boolean {
    if (this.user) {
      if (this.isCompanyAdministrationFeatureEnabled) {
        if (this.user.isGlobalAdmin) { return true; }
      } else if (this.user.role === UserRoles.admin) {return true; }
    }
    return false;
  }

  navigateToAddUser() {
    this._router.navigate(['/user/' + encodeURIComponent('new')]);
  }

  navigateToDetail(userId: string | undefined) {
    if (!userId) {
      return;
    }
    this._router.navigate(['/user/' + encodeURIComponent(userId)]);
  }

  refresh() {
    this.cols = [];
    this.usersReady = false;
    this.companyNamesSelection = [];
    this.messages = [];
    this.ngOnInit();
  }

  confirmDelete(user: User) {
    if (!user.id) {
      return;
    }
    this._confirmationService.confirm(
      {
        key: 'confirmationDialog',
        header: 'Delete Confirmation',
        message: 'Are you sure you want to delete ' + user.lastName + '?',
        icon: 'fa fa-question-circle',
        accept: () => { this.deleteUser(user.id); }// ,
        // reject: () => { }
      }
    );
  }

  deleteUser(userId: string | undefined) {
    if (!userId) {
      return;
    }
    this._userClient.delete(userId).subscribe(
      result => {
        this.refresh();
        this._messageService.infoMessage('User Deleted', '');
        this._applicationContextService.alertUserDetailsUpdated();
      },
      error => { this.handleError(error, 'Could not Delete User'); }
    );
  }

  handleError(error: any, displayMessage: string) {
    this._messageService.errorMessage(error, displayMessage);
  }

}
